import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetEWADetails } from '@/common/integrations/menhir/employee/salary/salary.hooks';
import { areActionsEnabled, isSchedulingAvailable } from '@/common/utils/ewa';
import { LoadingPlaceholder } from '@/web/components/LoadingPlaceholder/LoadingPlaceholder';
import { Redirect, Slot } from 'expo-router';

export default function EarnedWageAccessScheduleLayout() {
  const { details, isInitialLoading } = useGetEWADetails();
  const { employee } = useEmployeeDetails();

  if (isInitialLoading) {
    return <LoadingPlaceholder />;
  }

  if (
    !details ||
    !isSchedulingAvailable(details) ||
    !areActionsEnabled(details, employee)
  ) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }

  return <Slot />;
}
